
<div class="container">


  <h2 class="content-heading">
      
        Feast Types
  </h2>


<div class="block">

  <!--
  <div class="block-header block-header-default">
      <h3 class="block-title"></h3>
  </div>
-->

  <div class="block-content">
      <div class="table-responsive ">
          <table class="table table-striped table-vcenter table-sm">
              <thead>
                  <tr>
                    <th>Name</th>
                    <th>IsExclusive</th>
                    <th>IsTransferrable</th>  
                      <th class="text-center" style="width: 100px;">Actions</th>
                  </tr>
              </thead>
              <tbody>


                <tr *ngFor="let entity of entities">
                  <td class="font-w600">{{entity.Localized[0].Name}}</td>
                  <td class="font-w600">{{entity.IsExclusive}}</td>
                  <td class="font-w600">{{entity.IsTransferable}}</td> 
                  <td class="text-center">
                      <div class="btn-group">
                         <!-- <button type="button" class="btn btn-sm btn-secondary js-tooltip-enabled" data-toggle="tooltip" title="" data-original-title="Edit" (click)="editLanguage(lang)">
                              <i class="fa fa-pencil"></i>
                          </button> -->
                          
                      </div>
                  </td>
                </tr>

              </tbody>
          </table>

          <app-progress-bar *ngIf="isLoading==true"></app-progress-bar>
        </div>


  </div>

</div>

</div>

